import * as tslib_1 from "tslib";
import { HttpClient } from '@angular/common/http';
import { USER_ICON_MAP, UserType, } from '@models';
import { ODataService } from '@services/generics/odata.service';
import { MapperService } from '@services/mapper.service';
import { map } from 'rxjs/operators';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
export var DEFAULT_NOTIFICATION_SETTINGS = {
    transactions: true,
    robots: true,
    jobs: true,
    tasks: true,
    schedules: true,
    queues: true,
};
var UserService = /** @class */ (function (_super) {
    tslib_1.__extends(UserService, _super);
    function UserService(http) {
        var _this = _super.call(this, http, MapperService.userMap) || this;
        _this.suggest = function (searchTerm, fetchSize, skip, type) {
            if (fetchSize === void 0) { fetchSize = 20; }
            if (skip === void 0) { skip = 0; }
            var queryOptions = {
                select: ['UserName', 'Id', 'Type', 'RolesList'],
                orderBy: ['Type', 'UserName'],
                top: fetchSize,
                skip: skip,
            };
            if (searchTerm != null) {
                queryOptions.filter = {
                    UserName: {
                        contains: searchTerm,
                    },
                };
            }
            if (type != null) {
                queryOptions.filter = tslib_1.__assign({}, queryOptions.filter, { Type: {
                        eq: UserType[type],
                    } });
            }
            return _this
                .get(queryOptions)
                .pipe(map(function (_a) {
                var data = _a.data, total = _a.total;
                return ({
                    total: total,
                    data: data.map(function (user) { return ({
                        id: user.id,
                        text: user.userName,
                        icon: USER_ICON_MAP[user.type],
                    }); }),
                });
            }));
        };
        _this._endpoint = '/odata/Users';
        return _this;
    }
    UserService.prototype.importUsers = function (data) {
        data.group = (data.group || '').trim();
        var payload = JSON.stringify(data);
        return this._http.post(this._endpoint + "/UiPath.Server.Configuration.OData.ImportUsers", payload);
    };
    UserService.prototype.changePassword = function (userId, data) {
        var payload = JSON.stringify(this._toPoco(data, MapperService.changePasswordMap));
        return this._http
            .post(this._endpoint + "(" + userId + ")/UiPath.Server.Configuration.OData.ChangePassword", payload);
    };
    UserService.prototype.setActive = function (userId, active) {
        var payload = JSON.stringify({ active: active });
        return this._http.post(this._endpoint + "(" + userId + ")/UiPath.Server.Configuration.OData.SetActive", payload);
    };
    UserService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function UserService_Factory() { return new UserService(i0.ɵɵinject(i1.HttpClient)); }, token: UserService, providedIn: "root" });
    return UserService;
}(ODataService));
export { UserService };
